import React, { useState, useContext, useEffect } from 'react'

const AccessibleOnly = (props) => {
  return (
    <>
      <div className="sopa-map--filter-panel">
        <h3 className="sopa-map--filter-panel_heading">Accessibility</h3>
        <ul>
          <li className={`sopa-map--categories_item`} key='accessible-only-selector'>
            <label>
              <input
                id='accessible-only-check'
                type="checkbox"
                onChange={({target}) => {
                  props.setShowOnlyAccessible(target.checked)
                }}
              />
              <span className="sopa-map--categories_item-label">
                Show only accessible locations
              </span>
            </label>
          </li>
        </ul>
      </div>
    </>
  )
}

export default AccessibleOnly